export default __webpack_public_path__ + "static/media/logo-BPO.46701a71.png";